/**
 * Display-only substitution of generic "Speaker N" labels with the real names from
 * the refinement context (e.g. "Speaker 1" -> "Larry Fink"). 1-based: speakerNames[0]
 * is Speaker 1. Leaves a label untouched when no matching non-empty name exists, so a
 * partial name list never mislabels later speakers. Does not mutate the stored report.
 */
export function applySpeakerNames(content: string, speakerNames?: string[] | null): string {
  if (!content || !speakerNames || speakerNames.length === 0) return content;
  return content.replace(/\bSpeaker\s+(\d+)\b/g, (match, num) => {
    const name = speakerNames[Number(num) - 1];
    return name && name.trim() ? name.trim() : match;
  });
}
